import React, { Component, createRef, memo } from "react";
import { MqttContext } from "../../Contexts/MqttProvider.js";
import {
  apiDashboardVps,
  apiAccountMt4_ByAgent,
  // apiAccountList,
  apiDailyBalance,
  apiDailyBalanceByAgent,
  apiDailyProfit,
  apiDailyProfitByAgent,
  apiMonthlyAllProfit,
  // apiDashboardTakeProfit,
  apiDashboardDailyProfitAdmin,
  apiDashboardDailyWdAdmin,
  apiDashboardDailyDepositAdmin,
  apiDashboardDailyEquityBalanceAdmin,
  apiDashboardSumDeposit,
  apiDashboardSumProfit,
  apiDashboardSumWithdrawal,
  apiDashboardTotalAccountActive,
  apiSlaveListMaster,
  apiMasterSlaveFixVpsMonitor,
  apiMasterSlaveFixVpsMonitorAuto,
  apiActionReset,
  apiActionRestart,
  apiVpsSummary,
  apiVpsCapacity,
} from "../../Service/api";
import "./Dashboard.style.css";
import ReactTable from "react-table";
import {
  Box,
  Grid,
  Typography,
  Button,
  ButtonBase,
  ListItem,
  List,
  ListItemAvatar,
  ListItemText,
  Paper,
  TableCell,
  TableRow,
  TableContainer,
  TableHead,
  Table,
  TableBody,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Snackbar,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  DialogContent,
  DialogContentText,
  DialogActions,
  CircularProgress,
  Card,
  CardContent,
  Divider,
} from "@mui/material";
import {
  AccountBalanceWallet,
  MonetizationOn,
  Public,
  Terminal,
  People,
  Assignment,
  TrendingUp,
  TrendingDown,
  Payments,
  Payment,
  Timeline,
  RemoveCircleOutline,
  ExpandMore,
  // Handyman,
  RestartAlt,
  ResetTv,
  Close,
  Cancel,
  Check,
  DnsRounded,
  StorageRounded,
} from "@mui/icons-material";
import {
  getPreviousDay,
  getEstimationProfit,
  getEstimationProfitBTC,
  getEstimationProfitGOLD,
} from "../../../global.js";
import AccountMetricTabs from "../../Components/TabFloating";
import MuiAlert from "@mui/material/Alert";
import dayjs from "dayjs";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import $ from "jquery";
import "moment/locale/id";
import "./Dashboard.style.css";
moment.locale("id");

const stylesListDialog = {
  inline: {
    display: "inline",
  },
};

const stylesDialog = {
  appBar: {
    position: "relative",
    backgroundColor: "#03101e",
  },
  title: {
    marginLeft: 0,
    flex: 1,
    fontSize: 16,
  },
};

function numOrZero(v) {
  return v === undefined || v === null || v === "" ? 0 : Number(v);
}
function arr(a) {
  return Array.isArray(a) ? a : [];
}

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.mqttRef = React.createRef();
    this.reactTable = React.createRef();
    this.state = {
      community: props.community,
      tableData: [],
      tableDataSchedule: [],
      filter: "",
      total_account: 0,
      total_vps: 0,
      total_vps_on: 0,
      total_vps_off: 0,
      total_accounts: 0,
      total_account_active: 0,
      total_balance: 0,
      total_profit: 0,
      total_equity: 0,
      total_all_profit: 0,
      total_daily_profit: 0,
      total_daily_wd: 0,
      total_daily_deposit: 0,
      total_sum_profit: 0,
      total_sum_withdrawal: 0,
      total_sum_deposit: 0,
      total_sum_initial_deposit: 0,
      total_available_terminal: 0,
      capacityVps: [],
      loginInfo: "",

      notifSlave: [],
      notifIndex: 0,
      checked: true,
      expanded: null,
      slaveMaster: [],
      filteredVps: [],
      clickedRowIndex: null,
      sortConfig: { key: "vps", direction: "ascending" },
      snackbarMessage: "",
      snackbarSeverity: "success",

      topicTradeData: "TradedataV2/+/+",
      activeTab: 0,
      tabs: 2,
      result: null,
      EURUSD: {
        tradeTick: null,
        priceBuy: null,
        priceSell: null,
        groupOrderTick: [],
        tradeBuy: [],
        tradeSell: [],
        estBuyProfit: 0,
        estSellProfit: 0,
        spread: 0,
        totalBuyOrder: 0,
        totalSellOrder: 0,
        buyTakeProfit: 0,
        sellTakeProfit: 0,
        buyPointDiff: 0,
        sellPointDiff: 0,
      },
      XAUUSDc: {
        tradeTick: null,
        priceBuy: null,
        priceSell: null,
        tradeBuy: [],
        tradeSell: [],
        groupOrderTick: [],
        estBuyProfit: 0,
        estSellProfit: 0,
        spread: 0,
        totalBuyOrder: 0,
        totalSellOrder: 0,
        buyTakeProfit: 0,
        sellTakeProfit: 0,
        buyPointDiff: 0,
        sellPointDiff: 0,
      },
      BTCUSDc: {
        tradeTick: null,
        priceBuy: null,
        priceSell: null,
        tradeBuy: [],
        tradeSell: [],
        groupOrderTick: [],
        estBuyProfit: 0,
        estSellProfit: 0,
        spread: 0,
        totalBuyOrder: 0,
        totalSellOrder: 0,
        buyTakeProfit: 0,
        sellTakeProfit: 0,
        buyPointDiff: 0,
        sellPointDiff: 0,
      },

      HREU: {
        tradeTick: null,
        priceBuy: null,
        priceSell: null,
        tradeBuy: [],
        tradeSell: [],
        groupOrderTick: [],
        estBuyProfit: 0,
        estSellProfit: 0,
        spread: 0,
        totalBuyOrder: 0,
        totalSellOrder: 0,
        buyTakeProfit: 0,
        sellTakeProfit: 0,
        buyPointDiff: 0,
        sellPointDiff: 0,
      },

      showModalRestart: false,
      showModalReset: false,
      itemSelected: {},
      showLoading: false,
      summary_vps: [],
    };
    this.tableScrollTop = 0;
    this.tableColumns = [
      {
        Header: "No.",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "id",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        width: 80,
        Cell: (e) => (
          <Typography
            component="span"
            variant="body2"
            style={{
              display: "inline-block",
            }}
          >
            {e.original.id}
          </Typography>
        ),
      },
      {
        Header: "Last Timestamp",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "last_timestamp",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        width: 150,
        Cell: (e) => (
          <Typography component="span" variant="body2">
            {dayjs(e.original.last_timestamp).format("DD/MM/YYYY HH:mm:ss")}
          </Typography>
        ),
      },
      {
        Header: "Status",
        headerStyle: { fontWeight: "bold" },
        accessor: "vps_status",
        style: { textAlign: "center" },
        Cell: (e) => (
          <Typography
            component="span"
            variant="body2"
            style={{
              display: "inline-block",
              color:
                e.original.vps_status === "Offline" ||
                e.original.vps_status === "OFF"
                  ? "red"
                  : e.original.vps_status === "Busy"
                    ? "darkorange"
                    : "green",
              fontWeight: "600",
            }}
          >
            {e.original.vps_status}
          </Typography>
        ),
      },
      {
        Header: "VPS IP",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "vps_ip",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <Typography
            component="span"
            variant="body2"
            style={{
              display: "inline-block",
            }}
          >
            {e.original.vps_ip}
          </Typography>
        ),
      },
      {
        Header: "VPS Alias",
        headerStyle: { fontWeight: "bold" },
        accessor: "vps_name",
        style: { textAlign: "center" },
        Cell: (e) => (
          <Typography
            component="span"
            variant="body2"
            style={{
              display: "inline-block",
            }}
          >
            {e.original.vps_name}
          </Typography>
        ),
      },
      {
        Header: "Platform",
        headerStyle: { fontWeight: "bold" },
        accessor: "platform",
        style: { textAlign: "center" },
        Cell: (e) => (
          <Typography
            component="span"
            variant="body2"
            style={{
              display: "inline-block",
            }}
          >
            {e.original.platform}
          </Typography>
        ),
      },
      {
        Header: "Total Account",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "total",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <Typography
            component="span"
            variant="body2"
            style={{
              display: "inline-block",
            }}
          >
            {e.original.total}
          </Typography>
        ),
      },
      {
        Header: "Available Terminal",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "available_terminals",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <Typography
            component="span"
            variant="body2"
            style={{
              display: "inline-block",
            }}
          >
            {e.original.available_terminals}
          </Typography>
        ),
      },
      {
        Header: "Action",
        headerStyle: { fontWeight: "bold" },
        accessor: "",
        style: { textAlign: "center" },
        width: 500,
        Cell: (e) => (
          <div>
            <Button
              variant="contained"
              size="small"
              style={{
                backgroundColor: "#3f51b5",
              }}
              startIcon={<Assignment />}
              onClick={() => this.doRowEdit(e.original)}
            >
              <Typography
                variant="button"
                style={{
                  color: "#fff",
                  textTransform: "capitalize",
                }}
              >
                View
              </Typography>
            </Button>
            &nbsp;
            <Button
              variant="contained"
              size="small"
              style={{
                backgroundColor: "#194d33",
              }}
              startIcon={<RestartAlt />}
              onClick={() => this.doOpenModalRestart(e.original)}
            >
              <Typography
                variant="button"
                style={{
                  color: "#fff",
                  textTransform: "capitalize",
                }}
              >
                Restart Service
              </Typography>
            </Button>
            &nbsp;
            <Button
              variant="contained"
              size="small"
              style={{
                backgroundColor: "#ff6900",
              }}
              startIcon={<ResetTv />}
              onClick={() => this.doOpenModalReset(e.original)}
            >
              <Typography
                variant="button"
                style={{
                  color: "#fff",
                  textTransform: "capitalize",
                }}
              >
                Reset MT4
              </Typography>
            </Button>
          </div>
        ),
      },
    ];
    this.timer = null;
    this.masterSlaveTimer = null;
    this._isMounted = false;

    this.isSubscribed = false;

    this.activeTabRef = createRef();
    this.activeTabRef.current = 0;

    this.expandedRef = createRef();
    this.expandedRef.current = null;

    this.tradeDataRefs = {};
  }

  static contextType = MqttContext;

  componentDidMount() {
    // this.checkMqttConnection();

    this._isMounted = true;
    let loginInfo = localStorage.getItem("loginInfo");
    loginInfo = JSON.parse(loginInfo);
    this.setState({
      loginInfo: loginInfo,
    });
    this.doLoadData();
    this.doDailyProfitAdmin();
    this.doDailyEquityBalance();
    this.doDailyWdAdmin();
    this.doDailyDepositAdmin();
    this.doLoadVpsSummary();
    this.doLoadCapacityVps();
    // this.doLoadDataAccount();
    this.doTotalAccountActive();
    this.doLoadSum();
    this.doDailyMasterSlaveNotif();

    this.timer = setInterval(() => {
      if (this._isMounted) {
        this.doDailyEquityBalance();
        this.doDailyWdAdmin();
        this.doDailyDepositAdmin();
        this.doLoadVpsSummary();
        this.doLoadCapacityVps();
      }
    }, 10000);

    this.masterSlaveTimer = setInterval(() => {
      if (this._isMounted) {
        this.doDailyMasterSlaveNotif();
      }
    }, 60000);

    let params = {
      agent: loginInfo.agent,
      infoAccount: loginInfo.infoAccount,
      logintype: loginInfo.logintype,
    };

    if (loginInfo.logintype === 4) {
      // this.doLoadDataAccount();
      this.doLoadDailyBalance();
      this.doLoadDailyProfit();
      this.doLoadTotalAllProfit(params);
    } else if (loginInfo.logintype === 2 || loginInfo.logintype === 3) {
      this.doLoadDataAccountByAgent(loginInfo.agent.id);
      this.doLoadDailyBalanceByAgent(loginInfo.agent.id);
      this.doLoadDailyProfitByAgent(loginInfo.agent.id);
      this.doLoadTotalAllProfit(params);
    }
  }

  componentWillUnmount() {
    // const { unsubscribeFromTopic } = this.context;

    // if (this.isSubscribed) {
    //   unsubscribeFromTopic("TradedataV2/+/+");
    //   this.isSubscribed = false;
    // }

    this._isMounted = false;

    clearInterval(this.timer);
    clearInterval(this.masterSlaveTimer);
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    const {
      messagesTradeDataEURUSD,
      messagesTradeDataHREU,
      messagesTradeChartEURUSD,
      messagesTradeDataBTCUSDc,
      messagesTradeChartBTCUSDc,
      messagesTradeChartXAUUSDc,
      messagesTradeDataXAUUSDc,
    } = this.context;

    return (
      nextContext.messagesTradeDataEURUSD !== messagesTradeDataEURUSD ||
      nextContext.messagesTradeChartEURUSD !== messagesTradeChartEURUSD ||
      nextContext.messagesTradeDataBTCUSDc !== messagesTradeDataBTCUSDc ||
      nextContext.messagesTradeChartBTCUSDc !== messagesTradeChartBTCUSDc ||
      nextContext.messagesTradeDataXAUUSDc !== messagesTradeDataXAUUSDc ||
      nextContext.messagesTradeChartXAUUSDc !== messagesTradeChartXAUUSDc ||
      nextContext.messagesTradeDataHREU !== messagesTradeDataHREU
    );
  }

  checkMqttConnection() {
    const { isConnected, subscribeToTopic } = this.context;

    if (isConnected) {
      if (!this.isSubscribed) {
        // console.log("MQTT is connected:", isConnected);
        subscribeToTopic("TradedataV2/+/+");
        this.isSubscribed = true;
        // console.log("Successfully subscribed to TradedataV2/+/+");
      }
    } else {
      if (this.isSubscribed) {
        // console.log("MQTT is not connected.");
        this.isSubscribed = false;
      }
    }
  }

  handleTradeDataUpdate(tradeData, currency) {
    if (tradeData && Array.isArray(tradeData.groupOrders)) {
      const groupOrderTick = tradeData.groupOrders;
      const tradeBuy = tradeData.groupOrders.filter((item) => item.type === 0);
      const tradeSell = tradeData.groupOrders.filter((item) => item.type === 1);

      const totalBuyOrder = tradeBuy.length > 0 ? tradeBuy[0].totalOrder : 0;
      const totalSellOrder = tradeSell.length > 0 ? tradeSell[0].totalOrder : 0;

      const buyTakeProfit = tradeBuy.length > 0 ? tradeBuy[0].takeProfit : 0;
      const sellTakeProfit = tradeSell.length > 0 ? tradeSell[0].takeProfit : 0;

      const buyPointDiff = tradeBuy.length > 0 ? tradeBuy[0].pointDiff : 0;
      const sellPointDiff = tradeSell.length > 0 ? tradeSell[0].pointDiff : 0;

      const estimationBuy = tradeBuy.length > 0 ? tradeBuy[0].totalOrder : 0;
      const estimationSell = tradeSell.length > 0 ? tradeSell[0].totalOrder : 0;

      const estimationProfit =
        currency === "EURUSD"
          ? getEstimationProfit(estimationBuy, estimationSell)
          : currency === "XAUUSDc"
            ? getEstimationProfitGOLD(estimationBuy, estimationSell)
            : currency === "HREU"
              ? getEstimationProfit(estimationBuy, estimationSell)
              : getEstimationProfitBTC(estimationBuy, estimationSell);

      const ASK = tradeData.priceSell;
      const BID = tradeData.priceBuy;

      // console.table({ ASK, BID });

      const spread =
        currency === "EURUSD" || currency === "HREU"
          ? Math.round((ASK - BID) * 100000)
          : currency === "XAUUSDc"
            ? Math.round((ASK - BID) * 100)
            : Math.round(ASK - BID);

      // console.log("spread: ", spread);

      this.setState((prevState) => {
        const newCurrencyState = {
          tradeTick: tradeData,
          groupOrderTick: groupOrderTick,
          priceBuy: BID,
          priceSell: ASK,
          tradeBuy,
          tradeSell,
          estBuyProfit: estimationProfit.buy,
          estSellProfit: estimationProfit.sell,
          spread,
          totalBuyOrder,
          totalSellOrder,
          buyTakeProfit,
          sellTakeProfit,
          buyPointDiff,
          sellPointDiff,
        };

        if (
          JSON.stringify(prevState[currency]) !==
          JSON.stringify(newCurrencyState)
        ) {
          return { [currency]: newCurrencyState };
        }
        return null;
      });
    }
  }
  doDailyMasterSlaveNotif = () => {
    if (!this._isMounted) return;

    apiSlaveListMaster()
      .then((res) => {
        var data = res.data;
        if (data.status === "OK") {
          var tempData = Array.isArray(data.records) ? data.records : [];

          var masters = tempData.map(function (master) {
            var info = arr(master.infoSlave);
            var seenIp = Object.create(null);

            var mBuy = numOrZero(master && master.buy);
            var mSell = numOrZero(master && master.sell);

            var filteredVps = info.reduce(function (acc, slave) {
              var sBuy = numOrZero(slave && slave.buy);
              var sSell = numOrZero(slave && slave.sell);

              var buyDiff = Math.abs(mBuy - sBuy);
              var sellDiff = Math.abs(mSell - sSell);

              var isOutOfSync = buyDiff > 5 || sellDiff > 5;

              if (isOutOfSync) {
                var key =
                  slave.vps_ip || "no-ip-" + (slave.item_id || acc.length);
                if (!seenIp[key]) {
                  seenIp[key] = true;
                  acc.push(
                    Object.assign({}, slave, {
                      _buyDiff: buyDiff,
                      _sellDiff: sellDiff,
                    }),
                  );
                }
              }
              return acc;
            }, []);

            return Object.assign({}, master, { filteredVps: filteredVps });
          });

          this.setState({ slaveMaster: masters }, () => {
            this.forceUpdate();
          });
        }
      })
      .catch(function (err) {
        console.log("err: ", err);
      });
  };

  doDailyProfitAdmin = () => {
    apiDashboardDailyProfitAdmin()
      .then((res) => {
        // console.log("res: ", res);
        const data = res.data;
        if (data.status === "OK") {
          if (data.records.length > 0) {
            const profit = data.records[0].total_profit;
            const formattedProfit = new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
            }).format(profit);

            this.setState({
              total_daily_profit: formattedProfit,
            });
            this.forceUpdate();
          }
        }
      })
      .catch((err) => {
        console.log("err: ", err);
      });
  };

  doDailyWdAdmin = () => {
    if (this._isMounted) {
      apiDashboardDailyWdAdmin()
        .then((res) => {
          // console.log("res: ", res);
          const data = res.data;
          if (data.status === "OK") {
            if (data.records.length > 0) {
              const profit = data.records[0].total_profit;
              const formattedWd = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(profit);

              this.setState({
                total_daily_wd: formattedWd,
              });
              this.forceUpdate();
            }
          }
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    }
  };

  doDailyDepositAdmin = () => {
    if (this._isMounted) {
      apiDashboardDailyDepositAdmin()
        .then((res) => {
          // console.log("res: ", res);
          const data = res.data;
          if (data.status === "OK") {
            if (data.records.length > 0) {
              const profit = data.records[0].total_profit;
              const formattedWd = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(profit);

              this.setState({
                total_daily_deposit: formattedWd,
              });
              this.forceUpdate();
            }
          }
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    }
  };

  doLoadVpsSummary = () => {
    if (this._isMounted) {
      apiVpsSummary()
        .then((res) => {
          // console.log("res: ", res);
          const data = res.data;
          if (data.code === 200) {
            if (data.records.length > 0) {
              const total_terminal = data.records[0].total_teriminal;
              this.setState({
                summary_vps: data.records,
                total_available_terminal: total_terminal,
              });
              this.forceUpdate();
            }
          }
        })
        .catch((err) => {
          this.forceUpdate();
          console.log("err: ", err);
        });
    }
  };

  doLoadCapacityVps = () => {
    if (this._isMounted) {
      apiVpsCapacity()
        .then((res) => {
          const data = res.data;
          // console.log("res capacity vps: ", data);
          if (data.status === "success") {
            if (data.records.length > 0) {
              this.setState({
                capacityVps: data.records,
              });
              this.forceUpdate();
            }
          }
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    }
  };

  doTotalAccountActive = () => {
    apiDashboardTotalAccountActive()
      .then((res) => {
        // console.log("res: ", res);
        const data = res.data;
        if (data.status === "OK") {
          this.setState({
            total_account_active: data.total_active_accounts,
          });
          this.forceUpdate();
        }
      })
      .catch((err) => {
        console.log("err: ", err);
      });
  };

  doLoadSum = () => {
    apiDashboardSumDeposit()
      .then((res) => {
        const data = res.data;
        if (data.status === "OK") {
          if (data.records.length > 0) {
            const sumDeposit = data.records[0].sum_deposit;
            const formattedSumDeposit = new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
            }).format(sumDeposit);

            this.setState({
              total_sum_deposit: formattedSumDeposit,
            });
            this.forceUpdate();
          }
        }
      })
      .catch((err) => {
        console.log("err: ", err);
      });

    apiDashboardSumProfit()
      .then((res) => {
        const data = res.data;
        if (data.status === "OK") {
          if (data.records.length > 0) {
            const sumProfit = data.records[0].sum_profit;
            const formattedSumProfit = new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
            }).format(sumProfit);

            this.setState({
              total_sum_profit: formattedSumProfit,
            });
            this.forceUpdate();
          }
        }
      })
      .catch((err) => {
        console.log("err: ", err);
      });

    apiDashboardSumWithdrawal()
      .then((res) => {
        const data = res.data;
        if (data.status === "OK") {
          if (data.records.length > 0) {
            const sumWithdrawal = data.records[0].sum_withdrawal;
            const formattedSumWithdrawal = new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
            }).format(sumWithdrawal);

            this.setState({
              total_sum_withdrawal: formattedSumWithdrawal,
            });
            this.forceUpdate();
          }
        }
      })
      .catch((err) => {
        console.log("err: ", err);
      });

    // apiDashboardSumInitialDeposit()
    //   .then((res) => {
    //     const data = res.data;
    //     if (data.status === "OK") {
    //       if (data.records.length > 0) {
    //         const sumInitialDeposit = data.records[0].sum_initial_deposit;
    //         const formattedSumInitialDeposit = new Intl.NumberFormat("en-US", {
    //           style: "currency",
    //           currency: "USD",
    //         }).format(sumInitialDeposit);

    //         this.setState({
    //           total_sum_initial_deposit: formattedSumInitialDeposit,
    //         });
    //       }
    //     }
    //   })
    //   .catch((err) => {
    //     console.log("err: ", err);
    //   });
  };

  doDailyEquityBalance = () => {
    if (this._isMounted) {
      apiDashboardDailyEquityBalanceAdmin()
        .then((res) => {
          const data = res.data;
          if (data.status === "OK" && data.records.length > 0) {
            const equity = data.records[0].total_equity;
            const balance = data.records[0].total_balance;

            const formattedEquity = new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
            }).format(equity);

            const formattedBalance = new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
            }).format(balance);

            this.setState({
              total_equity: formattedEquity,
              total_balance: formattedBalance,
            });
            this.forceUpdate();
          }
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    }
  };

  sumArrayProperty = (data, propertyName) => {
    return data.reduce((sum, item) => sum + item[propertyName], 0);
  };

  getPreviousDay(date = new Date()) {
    const previous = new Date(date.getTime());
    previous.setDate(date.getDate() - 1);

    return previous;
  }

  // doLoadDataAccount = () => {
  //   apiAccountList()
  //     .then((res) => {
  //       let data = res.data;
  //       if (data.status === "OK") {
  //         if (data.records.length > 0) {
  //           var temp = data.records;

  //           if (this.state.loginInfo.logintype === 4) {
  //             const filteredData1 = temp.filter((item1) =>
  //               this.state.loginInfo.infoAccount.some(
  //                 (item2) => item2.account === item1.account_number
  //               )
  //             );

  //             const sumEquity = this.sumArrayProperty(filteredData1, "equity");

  //             const equityInUSD = sumEquity / 100;

  //             const formattedEquity = new Intl.NumberFormat("en-US", {
  //               style: "currency",
  //               currency: "USD",
  //             }).format(equityInUSD);

  //             this.setState({
  //               total_equity: formattedEquity,
  //               total_accounts: filteredData1.length,
  //             });
  //           } else {
  //             // const sumBalance = this.sumArrayProperty(temp, "balance");
  //             // const balanceInUSD = sumBalance / 100;
  //             // const formattedBalance = new Intl.NumberFormat("en-US", {
  //             //   style: "currency",
  //             //   currency: "USD",
  //             // }).format(balanceInUSD);
  //             // const sumEquity = this.sumArrayProperty(temp, "equity");
  //             // const equityInUSD = sumEquity / 100;
  //             // const formattedEquity = new Intl.NumberFormat("en-US", {
  //             //   style: "currency",
  //             //   currency: "USD",
  //             // }).format(equityInUSD);
  //             // const dataToPrint = [
  //             //   { balance: formattedBalance, equity: formattedEquity },
  //             // ];
  //             // console.table(dataToPrint);
  //           }
  //         }
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  doLoadTotalAllProfit = (params) => {
    apiMonthlyAllProfit(params)
      .then((res) => {
        const data = res.data;
        if (data.status === "00") {
          const formattedTotalProfit = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
          }).format(data.total_all_profit);

          this.setState({
            total_all_profit: formattedTotalProfit,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  doLoadDataAccountByAgent = (agent_id) => {
    apiAccountMt4_ByAgent(agent_id)
      .then((res) => {
        let data = res.data;
        if (data.status === "OK") {
          if (data.records.length > 0) {
            var temp = data.records;

            if (this.state.loginInfo.logintype === 3) {
              const filteredData1 = temp.filter((item1) =>
                this.state.loginInfo.infoAccount.some(
                  (item2) => item2.account === item1.account_number,
                ),
              );

              const sumEquity = this.sumArrayProperty(filteredData1, "equity");

              const equityInUSD = sumEquity / 100;

              const formattedEquity = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(equityInUSD);

              this.setState({
                total_equity: formattedEquity,
                total_accounts: filteredData1.length,
              });
            } else {
              const sumEquity = this.sumArrayProperty(temp, "equity");

              const equityInUSD = sumEquity / 100;

              const formattedEquity = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(equityInUSD);

              this.setState({
                total_equity: formattedEquity,
                total_accounts: temp.length,
              });
            }
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  doLoadDailyBalance = () => {
    apiDailyBalance()
      .then((res) => {
        let data = res.data;
        if (data.status === "OK") {
          if (data.records.length > 0) {
            var dataDailyBalance = [];
            dataDailyBalance = data.records;

            const format1 = "YYYY-MM-DD";
            var date = new Date();
            var DateTimeNow = moment(date).format(format1);
            var day1Previous = moment(
              getPreviousDay(new Date(DateTimeNow), 1),
            ).format(format1);
            // var day2Previous = moment(
            //   getPreviousDay(new Date(DateTimeNow), 2)
            // ).format(format1);

            let arrayCurrentDate = dataDailyBalance.filter(
              (obj) => obj.last_update_date === DateTimeNow,
            );

            let arrayPreviousDate = dataDailyBalance.filter(
              (obj) => obj.last_update_date === day1Previous,
            );

            // let arrayPreviousTwoDate = dataDailyBalance.filter(
            //   (obj) => obj.last_update_date === day2Previous
            // );

            for (var a = 0; a < arrayCurrentDate.length; a++) {
              for (var b = 0; b < arrayPreviousDate.length; b++) {
                if (
                  arrayCurrentDate[a].account_number ===
                  arrayPreviousDate[b].account_number
                ) {
                  if (arrayCurrentDate[a].first_input === 1) {
                    // arrayCurrentDate[a].id = a + 1;
                    arrayCurrentDate[a].profit =
                      arrayCurrentDate[a].balance - arrayCurrentDate[a].capital;
                  } else {
                    // arrayCurrentDate[a].id = a + 1;
                    arrayCurrentDate[a].profit =
                      arrayCurrentDate[a].balance -
                      arrayPreviousDate[b].balance;
                  }
                } else {
                  if (arrayCurrentDate[a].first_input === 1) {
                    // arrayCurrentDate[a].id = a + 1;
                    arrayCurrentDate[a].profit =
                      arrayCurrentDate[a].balance - arrayCurrentDate[a].capital;
                  }
                }
              }
            }

            const dataArr = arrayCurrentDate;

            if (this.state.loginInfo.logintype === 4) {
              const filterDataDaily = dataArr.filter((item1) =>
                this.state.loginInfo.infoAccount.some(
                  (item2) => item2.account === item1.account_number,
                ),
              );

              const sumBalance = this.sumArrayProperty(
                filterDataDaily,
                "balance",
              );

              const balanceInUSD = sumBalance / 100;

              const formattedBalance = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(balanceInUSD);

              this.setState({
                total_balance: formattedBalance,
              });
            }
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  doLoadDailyBalanceByAgent = (agent_id) => {
    apiDailyBalanceByAgent(agent_id)
      .then((res) => {
        let data = res.data;
        if (data.status === "OK") {
          if (data.records.length > 0) {
            var dataDailyBalance = [];
            dataDailyBalance = data.records;

            const format1 = "YYYY-MM-DD";
            var date = new Date();
            var DateTimeNow = moment(date).format(format1);
            var day1Previous = moment(
              getPreviousDay(new Date(DateTimeNow), 1),
            ).format(format1);
            // var day2Previous = moment(
            //   getPreviousDay(new Date(DateTimeNow), 2)
            // ).format(format1);

            let arrayCurrentDate = dataDailyBalance.filter(
              (obj) => obj.last_update_date === DateTimeNow,
            );

            let arrayPreviousDate = dataDailyBalance.filter(
              (obj) => obj.last_update_date === day1Previous,
            );

            // let arrayPreviousTwoDate = dataDailyBalance.filter(
            //   (obj) => obj.last_update_date === day2Previous
            // );

            for (var a = 0; a < arrayCurrentDate.length; a++) {
              for (var b = 0; b < arrayPreviousDate.length; b++) {
                if (
                  arrayCurrentDate[a].account_number ===
                  arrayPreviousDate[b].account_number
                ) {
                  if (arrayCurrentDate[a].first_input === 1) {
                    // arrayCurrentDate[a].id = a + 1;
                    arrayCurrentDate[a].profit =
                      arrayCurrentDate[a].balance - arrayCurrentDate[a].capital;
                  } else {
                    // arrayCurrentDate[a].id = a + 1;
                    arrayCurrentDate[a].profit =
                      arrayCurrentDate[a].balance -
                      arrayPreviousDate[b].balance;
                  }
                } else {
                  if (arrayCurrentDate[a].first_input === 1) {
                    // arrayCurrentDate[a].id = a + 1;
                    arrayCurrentDate[a].profit =
                      arrayCurrentDate[a].balance - arrayCurrentDate[a].capital;
                  }
                }
              }
            }

            const dataArr = arrayCurrentDate;

            if (this.state.loginInfo.logintype === 3) {
              const filterDataDaily = dataArr.filter((item1) =>
                this.state.loginInfo.infoAccount.some(
                  (item2) => item2.account === item1.account_number,
                ),
              );

              const sumBalance = this.sumArrayProperty(
                filterDataDaily,
                "balance",
              );

              const balanceInUSD = sumBalance / 100;

              const formattedBalance = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(balanceInUSD);

              this.setState({
                total_balance: formattedBalance,
              });
            } else {
              const sumBalance = this.sumArrayProperty(dataArr, "balance");

              const balanceInUSD = sumBalance / 100;

              const formattedBalance = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(balanceInUSD);

              this.setState({
                total_balance: formattedBalance,
              });
            }
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  doLoadDailyProfit = () => {
    apiDailyProfit()
      .then((res) => {
        let data = res.data;
        if (data.status === "OK") {
          if (data.records.length > 0) {
            var dataDailyProfit = [];
            dataDailyProfit = data.records;

            if (this.state.loginInfo.logintype === 4) {
              const filterDataDaily = dataDailyProfit.filter((item1) =>
                this.state.loginInfo.infoAccount.some(
                  (item2) => item2.account === item1.account_number,
                ),
              );

              const sumProfit = this.sumArrayProperty(
                filterDataDaily,
                "profit",
              );

              const profitInUSD = sumProfit / 100;

              const formattedProfit = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(profitInUSD);

              this.setState({
                total_profit: formattedProfit,
              });
            }
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  doLoadDailyProfitByAgent = (agent_id) => {
    apiDailyProfitByAgent(agent_id)
      .then((res) => {
        let data = res.data;
        if (data.status === "OK") {
          if (data.records.length > 0) {
            var dataDailyProfit = [];
            dataDailyProfit = data.records;

            if (this.state.loginInfo.logintype === 3) {
              const filterDataDaily = dataDailyProfit.filter((item1) =>
                this.state.loginInfo.infoAccount.some(
                  (item2) => item2.account === item1.account_number,
                ),
              );

              const sumProfit = this.sumArrayProperty(
                filterDataDaily,
                "profit",
              );

              const profitInUSD = sumProfit / 100;

              const formattedProfit = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(profitInUSD);

              this.setState({
                total_profit: formattedProfit,
              });
            } else {
              const sumProfit = this.sumArrayProperty(
                dataDailyProfit,
                "profit",
              );

              const profitInUSD = sumProfit / 100;

              const formattedProfit = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(profitInUSD);

              this.setState({
                total_profit: formattedProfit,
              });
            }
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  doLoadData = () => {
    if (this.state.tableData.length === 0) {
      this.props.doLoading();
    }
    apiDashboardVps()
      .then((res) => {
        if (this.state.tableData.length === 0) {
          this.props.doLoading();
        }
        let data = res.data;
        if (data.status === "OK") {
          let temp = [...data.records];
          for (var i = 0; i < temp.length; i++) {
            temp[i].id = i + 1;
            temp[i].total =
              temp[i].total !== undefined && temp[i].total !== null
                ? Number(temp[i].total)
                : arr(temp[i].account_list).length;
          }

          function isRecentUpdate(lastTimestamp) {
            let now = new Date();
            let lastUpdate = new Date(lastTimestamp);
            let difference = now - lastUpdate;
            let differenceInMinutes = difference / (1000 * 60);
            return differenceInMinutes < 5;
          }

          temp.forEach((item) => {
            if (!isRecentUpdate(item.last_timestamp)) {
              item.vps_status =
                item.flag_auto === 1 ? item.vps_status : "Offline";
            } else {
              item.vps_status =
                item.flag_auto === 1 ? item.vps_status : "Online";
            }
          });

          let total_vps_on = temp.filter((obj) => obj.vps_status !== "Offline");
          let total_vps_off = temp.filter(
            (obj) => obj.vps_status === "Offline",
          );

          this.setState({
            tableData: temp,
            total_vps: temp.length,
            total_vps_on: total_vps_on.length,
            total_vps_off: total_vps_off.length,
            total_account: data.total_account,
          });
          this.forceUpdate();
          // timer = setTimeout(() => this.doLoadData(), 30000);
        }
      })
      .catch((err) => {
        if (this.state.tableData.length === 0) {
          this.props.doLoading();
        }
        console.log(err);
      });
  };

  doRowEdit = (row) => {
    this.props.history.push("/panel/vps-detail/" + row.code_vps);
  };

  handleCloseModal = () => {
    this.setState({
      itemSelected: {},
      showModalRestart: false,
      showModalReset: false,
    });
    this.forceUpdate();
  };

  doOpenModalRestart = (data) => {
    // console.log("Asd");
    const item = data;
    this.setState({
      showModalRestart: true,
      itemSelected: item,
    });
    this.forceUpdate();
  };

  doOpenModalReset = (data) => {
    const item = data;
    this.setState({
      showModalReset: true,
      itemSelected: item,
    });
    this.forceUpdate();
  };

  doRestartService = (data) => {
    const item = data;

    let paramAutoRestart = {
      vps_id: item.vps_id,
      vps: item.vps_label,
      action: "restart",
      client_id: this.state.loginInfo.phoneno,
    };

    this.props.doLoading();
    apiActionRestart(paramAutoRestart)
      .then((res) => {
        this.props.doLoading();
        const data = res.data;
        if (data.status === "success") {
          this.showSnackbar(`Sucessfully restart ${item.vps_label}`, "success");
        } else {
          this.showSnackbar(data.message, "error");
        }
        this.handleCloseModal();
      })
      .catch((err) => {
        this.props.doLoading();
        console.error(err);
        this.handleCloseModal();
      });
  };

  doReset = (data) => {
    const item = data;

    let paramAutoReset = {
      vps_id: item.vps_id,
      vps: item.vps_label,
      action: "reset",
      client_id: this.state.loginInfo.phoneno,
    };

    this.props.doLoading();
    apiActionReset(paramAutoReset)
      .then((res) => {
        this.props.doLoading();
        const data = res.data;
        if (data.status === "success") {
          this.showSnackbar(`Sucessfully reset ${item.vps_label}`, "success");
        } else {
          this.showSnackbar(data.message, "error");
        }
        this.handleCloseModal();
      })
      .catch((err) => {
        this.props.doLoading();
        console.error(err);
        this.handleCloseModal();
      });
  };

  handleChangeAccordion = (expanded) => {
    this.expandedRef.current =
      expanded === this.expandedRef.current ? null : expanded;
    this.forceUpdate();
  };

  showSnackbar = (message, severity) => {
    this.setState({
      snackbarMessage: message,
      snackbarSeverity: severity,
      openSnackbar: true,
      clickedRowIndex: null,
    });
  };

  handleCloseSnackbar = () => {
    this.setState({ openSnackbar: false });
  };

  handleRowClick = (item, index, data) => {
    this.setState({
      clickedRowIndex: index,
    });

    // console.log(data);
    // console.log(item);

    if (item.flag_auto === 1) {
      let paramFixAuto = {
        vps_id: item.vps_id,
        vps: item.vps,
        action: "fix",
        client_id: this.state.loginInfo.phoneno,
      };

      this.props.doLoading();
      apiMasterSlaveFixVpsMonitorAuto(paramFixAuto)
        .then((res) => {
          this.props.doLoading();
          const data = res.data;
          if (data.status === "success") {
            this.showSnackbar(`Sucessfully fixed VPS ${item.vps}`, "success");
          } else {
            this.showSnackbar(data.message, "error");
          }
        })
        .catch((err) => {
          this.props.doLoading();
          console.error(err);
        });
    } else {
      let param = {
        vps: item.vps_ip,
        vps_name: item.vps,
        accountMaster: data.account_number,
      };

      this.props.doLoading();
      apiMasterSlaveFixVpsMonitor(param)
        .then((res) => {
          this.props.doLoading();
          let data = res.data;
          if (data.status === 0) {
            this.showSnackbar(data.message, "error");
          } else {
            this.showSnackbar(`Sucessfully fixed VPS ${item.vps}`, "success");
            this.doDailyMasterSlaveNotif();
          }
        })
        .catch((err) => {
          this.props.doLoading();
          console.log(err);
        });
    }
  };

  doFixAll = async (data) => {
    const uniqueVPS = new Set();
    const closeVpsData = data.filter((item) => {
      if (!uniqueVPS.has(item.vps)) {
        uniqueVPS.add(item.vps);
        return true;
      }
      return false;
    });

    try {
      this.props.doLoading();

      const promises = closeVpsData.map(async (item) => {
        try {
          if (item.flag_auto === 1) {
            const paramFixAuto = {
              vps_id: item.vps_id,
              vps: item.vps,
              action: "fix",
              client_id: this.state.loginInfo.phoneno,
            };
            const { data } =
              await apiMasterSlaveFixVpsMonitorAuto(paramFixAuto);

            if (data.status === "success") {
              this.showSnackbar(
                `Successfully fixed VPS ${item.vps}`,
                "success",
              );
            } else {
              this.showSnackbar(data.message, "error");
            }
          } else {
            const param = {
              vps: item.vps_ip,
              vps_name: item.vps,
              accountMaster: item.account_number,
            };

            const { data } = await apiMasterSlaveFixVpsMonitor(param);

            if (data.status === 0) {
              this.showSnackbar(data.message, "error");
            } else {
              this.showSnackbar(
                `Successfully fixed VPS ${item.vps}`,
                "success",
              );
            }
          }
        } catch (err) {
          console.error(`Error fixing vps ${item.vps}:`, err);
          this.showSnackbar(`Error fixing vps ${item.vps}`, "error");
        }
      });

      await Promise.all(promises);

      this.props.doLoading();
      this.doDailyMasterSlaveNotif();
    } catch (err) {
      console.error("Error processing items:", err);
      this.showSnackbar("An unexpected error occurred", "error");

      this.props.doLoading();
    }
  };

  handleTabClick = (index) => {
    if (this.activeTabRef.current !== index) {
      this.activeTabRef.current = index;
      this.forceUpdate();
    }
  };

  renderModalRestart = () => {
    let item = this.state.itemSelected;
    return (
      <Dialog
        open={this.state.showModalRestart}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        maxWidth="sm"
      >
        <AppBar style={stylesDialog.appBar}>
          <Toolbar>
            <Typography
              component="span"
              variant="h2"
              style={stylesDialog.title}
            >
              Restart Service
            </Typography>
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => this.handleCloseModal()}
              aria-label="close"
            >
              <Close />
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent style={{ marginTop: 10 }}>
          <DialogContentText id="alert-dialog-description">
            <Typography
              component="span"
              variant="body2"
              style={(stylesListDialog.inline, { fontSize: 16, color: "#333" })}
            >
              Are you sure want to restart the service {item.vps_name}?
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            disabled={this.state.showLoading}
            variant="contained"
            size="small"
            style={{
              backgroundColor: "#808080",
            }}
            startIcon={<Cancel />}
            onClick={this.handleCloseModal}
          >
            <Typography
              variant="button"
              style={{
                color: "#fff",
                textTransform: "capitalize",
              }}
            >
              Cancel
            </Typography>
          </Button>{" "}
          <Button
            disabled={this.state.showLoading}
            variant="contained"
            size="small"
            style={{
              backgroundColor: "#0693e3",
            }}
            startIcon={this.state.showLoading === true ? null : <Check />}
            onClick={() => this.doRestartService(item)}
          >
            {this.state.showLoading === true ? (
              <CircularProgress style={{ color: "#fff" }} size={24} />
            ) : (
              <Typography
                variant="button"
                style={{
                  color: "#fff",
                  textTransform: "capitalize",
                }}
              >
                Yes
              </Typography>
            )}
          </Button>{" "}
        </DialogActions>
      </Dialog>
    );
  };

  renderModalReset = () => {
    let item = this.state.itemSelected;
    return (
      <Dialog
        open={this.state.showModalReset}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        maxWidth="sm"
      >
        <AppBar style={stylesDialog.appBar}>
          <Toolbar>
            <Typography
              component="span"
              variant="h2"
              style={stylesDialog.title}
            >
              Reset Meta Trader
            </Typography>
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => this.handleCloseModal()}
              aria-label="close"
            >
              <Close />
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent style={{ marginTop: 10 }}>
          <DialogContentText id="alert-dialog-description">
            <Typography
              component="span"
              variant="body2"
              style={(stylesListDialog.inline, { fontSize: 16, color: "#333" })}
            >
              Are you sure you want to reset Meta Trader on {item.vps_name}?
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            disabled={this.state.showLoading}
            variant="contained"
            size="small"
            style={{
              backgroundColor: "#808080",
            }}
            startIcon={<Cancel />}
            onClick={this.handleCloseModal}
          >
            <Typography
              variant="button"
              style={{
                color: "#fff",
                textTransform: "capitalize",
              }}
            >
              Cancel
            </Typography>
          </Button>{" "}
          <Button
            disabled={this.state.showLoading}
            variant="contained"
            size="small"
            style={{
              backgroundColor: "#0693e3",
            }}
            startIcon={this.state.showLoading === true ? null : <Check />}
            onClick={() => this.doReset(item)}
          >
            {this.state.showLoading === true ? (
              <CircularProgress style={{ color: "#fff" }} size={24} />
            ) : (
              <Typography
                variant="button"
                style={{
                  color: "#fff",
                  textTransform: "capitalize",
                }}
              >
                Yes
              </Typography>
            )}
          </Button>{" "}
        </DialogActions>
      </Dialog>
    );
  };

  renderVpsSummary = () => {
    const { capacityVps } = this.state;
    if (!Array.isArray(capacityVps) || capacityVps.length === 0) {
      return null;
    }

    const platformConfig = {
      MT4: {
        color: "#194d33",
        icon: <StorageRounded />,
      },
      MT5: {
        color: "#194d33",
        icon: <DnsRounded />,
      },
    };

    return (
      <Box sx={{ width: "100%", p: { xs: 1, sm: 2 } }}>
        <Typography
          variant="h5"
          align="center"
          gutterBottom
          sx={{
            fontWeight: 600,
            mb: 3,
            fontSize: { xs: "1.1rem", sm: "1.3rem", md: "1.5rem" },
          }}
        >
          Active VPS Capacity{" "}
        </Typography>

        <Grid container spacing={3}>
          {capacityVps.map((item, index) => {
            const cfg = platformConfig[item.platform];

            return (
              <Grid item xs={12} md={6} key={index}>
                <Card
                  sx={{
                    height: "100%",
                    borderRadius: 3,
                    boxShadow: 4,
                    borderLeft: `6px solid ${cfg.color}`,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <CardContent sx={{ width: "100%" }}>
                    {/* Header */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 2,
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 600,
                          fontSize: { xs: "1rem", sm: "1.1rem", md: "1.25rem" },
                        }}
                      >
                        {item.platform}
                      </Typography>

                      <Box
                        sx={{
                          bgcolor: cfg.color,
                          color: "#fff",
                          borderRadius: "50%",
                          width: { xs: 44, sm: 52 },
                          height: { xs: 44, sm: 52 },
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {React.cloneElement(cfg.icon, {
                          sx: { fontSize: { xs: 24, sm: 30 } },
                        })}
                      </Box>
                    </Box>

                    {/* Available */}
                    <Typography
                      variant="caption"
                      sx={{ color: "text.secondary" }}
                    >
                      Available Terminal
                    </Typography>

                    <Typography
                      sx={{
                        fontWeight: 700,
                        color: cfg.color,
                        fontSize: { xs: "1.8rem", sm: "2.2rem", md: "2.5rem" },
                        lineHeight: 1.2,
                      }}
                    >
                      {item.total_available_terminals}
                    </Typography>

                    <Divider sx={{ my: 1.5 }} />

                    {/* Footer */}
                    <Typography
                      variant="body2"
                      sx={{
                        color: "text.secondary",
                        fontSize: { xs: "0.8rem", sm: "0.9rem" },
                      }}
                    >
                      Total VPS:{" "}
                      <Box
                        component="span"
                        sx={{ color: cfg.color, fontWeight: 600 }}
                      >
                        {item.total_vps}
                      </Box>
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    );
  };

  render() {
    const {
      slaveMaster,
      clickedRowIndex,
      total_vps_on,
      total_vps_off,
      total_available_terminal,
      total_account,
      total_account_active,
      total_balance,
      total_equity,
      total_daily_profit,
      total_sum_profit,
      total_daily_deposit,
      total_sum_deposit,
      total_daily_wd,
      total_sum_withdrawal,
      tableData,
      openSnackbar,
      snackbarSeverity,
      snackbarMessage,
    } = this.state;

    const link_vps = () => this.props.history.push("/panel/vps");
    const link_accounts = () => this.props.history.push("/panel/accounts");
    const link_daily_profit = () =>
      this.props.history.push("/panel/daily-profit");
    const link_daily_deposit = () =>
      this.props.history.push("/panel/daily-deposit");
    const link_daily_withdrawal = () =>
      this.props.history.push("/panel/daily-withdrawal");

    var totalOutAll = Array.isArray(slaveMaster)
      ? slaveMaster.reduce(function (sum, m) {
          return sum + (m && m.filteredVps ? m.filteredVps.length : 0);
        }, 0)
      : 0;

    var mastersWithIssue = Array.isArray(slaveMaster)
      ? slaveMaster.filter(function (m) {
          return m && m.filteredVps && m.filteredVps.length > 0;
        })
      : [];

    return (
      <>
        <Box sx={{ flexGrow: 1 }} mb={3}>
          <AccountMetricTabs />
          {totalOutAll > 0 ? (
            <Accordion
              key="ALL"
              onChange={() => this.handleChangeAccordion("ALL")}
              expanded={this.expandedRef.current === "ALL"}
              style={{
                marginBottom: 16,
                backgroundColor: "#1f324b",
                borderRadius: 6,
                color: "white",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMore style={{ color: "white" }} />}
                aria-controls="ALL-content"
                id="ALL-header"
              >
                <Typography
                  sx={{
                    fontWeight: "bold",
                    fontSize: { xs: "0.7rem", sm: "0.85rem", md: "0.95rem" },
                  }}
                >
                  {"Information: Total " +
                    String(totalOutAll) +
                    " VPS with Buy/Sell difference > 5"}
                </Typography>
              </AccordionSummary>

              <AccordionDetails>
                {mastersWithIssue.length > 0
                  ? mastersWithIssue.map((master) => {
                      var masterKey = master.account_master;
                      return (
                        <Box
                          key={masterKey}
                          sx={{
                            mb: 2,
                            p: 1.5,
                            borderRadius: 1,
                            backgroundColor: "rgba(255,255,255,0.06)",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: "bold",
                              mb: 1,
                              fontSize: {
                                xs: "0.75rem",
                                sm: "0.85rem",
                                md: "0.9rem",
                              },
                            }}
                          >
                            {(master.label || "") +
                              " (" +
                              String(master.account_master || "") +
                              ") - " +
                              "Buy(" +
                              String(master.buy || 0) +
                              ")/Sell(" +
                              String(master.sell || 0) +
                              ")"}
                          </Typography>

                          <TableListSlave
                            master={master}
                            data={master.filteredVps}
                            clickedRowIndex={clickedRowIndex}
                            handleRowClick={this.handleRowClick}
                            doFixAll={this.doFixAll}
                          />
                        </Box>
                      );
                    })
                  : null}
              </AccordionDetails>
            </Accordion>
          ) : null}

          <CardBoxInfo
            total_vps_on={total_vps_on}
            total_vps_off={total_vps_off}
            total_available_terminal={total_available_terminal}
            total_account={total_account}
            total_account_active={total_account_active}
            total_balance={total_balance}
            total_equity={total_equity}
            total_daily_profit={total_daily_profit}
            total_sum_profit={total_sum_profit}
            total_daily_deposit={total_daily_deposit}
            total_sum_deposit={total_sum_deposit}
            total_daily_wd={total_daily_wd}
            total_sum_withdrawal={total_sum_withdrawal}
            link_vps={link_vps}
            link_accounts={link_accounts}
            link_daily_profit={link_daily_profit}
            link_daily_deposit={link_daily_deposit}
            link_daily_withdrawal={link_daily_withdrawal}
          />
        </Box>
        {this.renderVpsSummary()}
        <Box sx={{ flexGrow: 1 }} mb={3} mt={1}>
          <TableDataVps
            tableData={tableData}
            tableColumns={this.tableColumns}
          />
        </Box>
        <AlertInfo
          openSnackbar={openSnackbar}
          snackbarSeverity={snackbarSeverity}
          snackbarMessage={snackbarMessage}
          handleCloseSnackbar={this.handleCloseSnackbar}
        />
        {this.renderModalRestart()}
        {this.renderModalReset()}
      </>
    );
  }
}

const TableListSlave = memo(function TableListSlave(props) {
  // var master = props.master;
  var data = Array.isArray(props.data) ? props.data : [];
  var clickedRowIndex = props.clickedRowIndex;
  // var handleRowClick = props.handleRowClick;

  return (
    <Grid item lg={12} md={12} sm={12} xs={12} style={{ marginBottom: 16 }}>
      <TableContainer component={Paper} sx={{ borderRadius: 1 }}>
        <Table
          stickyHeader
          size="small"
          aria-label="slave vps table"
          sx={{
            width: "100%",
            // Mobile auto (biar fleksibel), md+ fixed (stabil)
            tableLayout: { xs: "auto", md: "fixed" },
            "& th, & td": {
              fontSize: { xs: "0.72rem", sm: "0.8rem", md: "0.9rem" },
              py: { xs: 0.5, sm: 0.75, md: 1 },
            },
          }}
        >
          <TableHead>
            <TableRow
              sx={{
                "& th": {
                  fontWeight: 700,
                  backgroundColor: "#f3f4f6",
                  lineHeight: 1.1,
                },
              }}
            >
              {/* VPS */}
              <TableCell
                sx={{
                  width: { xs: "42%", md: "48%", lg: "50%" },
                  whiteSpace: { xs: "nowrap", md: "normal" },
                }}
              >
                VPS
              </TableCell>

              {/* Account -> Acct (xs) */}
              <TableCell
                sx={{ width: { xs: "32%", md: "26%", lg: "25%" } }}
                align="left"
              >
                <Box sx={{ display: { xs: "inline", sm: "none" } }}>Acct</Box>
                <Box sx={{ display: { xs: "none", sm: "inline" } }}>
                  Account
                </Box>
              </TableCell>

              {/* Buy */}
              <TableCell
                sx={{ width: { xs: "13%", md: "13%", lg: "12%" } }}
                align="right"
              >
                Buy
              </TableCell>

              {/* Sell */}
              <TableCell
                sx={{ width: { xs: "13%", md: "13%", lg: "13%" } }}
                align="right"
              >
                Sell
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {data.map(function (item, index) {
              var sBuy = numOrZero(item && item.buy);
              var sSell = numOrZero(item && item.sell);

              return (
                <TableRow
                  hover
                  key={(item && item.item_id) || index}
                  // onClick={function () {
                  //   if (handleRowClick) handleRowClick(item, index, master);
                  // }}
                  sx={{
                    cursor: "pointer",
                    backgroundColor:
                      clickedRowIndex === index ? "#e3f2fd" : "inherit",
                  }}
                >
                  <TableCell
                    sx={{
                      whiteSpace: { xs: "nowrap", md: "normal" },
                      overflow: { xs: "hidden", md: "visible" },
                      textOverflow: { xs: "ellipsis", md: "clip" },
                      maxWidth: { xs: 160, sm: "unset" },
                    }}
                  >
                    {(item && item.vps) || "-"}
                  </TableCell>

                  <TableCell sx={{ whiteSpace: "nowrap" }}>
                    {(item && item.account_number) || "-"}
                  </TableCell>

                  <TableCell
                    align="right"
                    sx={{
                      fontFamily:
                        '"Roboto Mono", ui-monospace, Menlo, monospace',
                    }}
                  >
                    {String(sBuy)}
                  </TableCell>

                  <TableCell
                    align="right"
                    sx={{
                      fontFamily:
                        '"Roboto Mono", ui-monospace, Menlo, monospace',
                    }}
                  >
                    {String(sSell)}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
});

const CardBoxInfo = ({
  total_vps_on,
  total_vps_off,
  total_available_terminal,
  total_account,
  total_account_active,
  total_balance,
  total_equity,
  total_daily_profit,
  total_sum_profit,
  total_daily_deposit,
  total_sum_deposit,
  total_daily_wd,
  total_sum_withdrawal,
  link_vps,
  link_accounts,
  link_daily_profit,
  link_daily_deposit,
  link_daily_withdrawal,
}) => (
  <>
    <Grid Grid container spacing={2} mb={3}>
      <Grid item xs={6} sm={6} md={3} sx={{ textAlign: "center" }}>
        <div className="dashboard-panel">
          <List>
            <ListItem
              alignItems="center"
              style={{
                margin: 0,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                padding: 0,
              }}
              onClick={link_vps}
            >
              <ListItemAvatar
                style={{
                  margin: 0,
                  backgroundColor: "#59C9B6",
                  borderRadius: 6,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <ButtonBase style={{ height: 80, width: 100 }}>
                  <Public
                    style={{
                      margin: "auto",
                      color: "#fff",
                      height: "100%",
                      width: "100%",
                      borderRadius: 5,
                      objectFit: "cover",
                    }}
                  />
                </ButtonBase>
              </ListItemAvatar>
            </ListItem>

            <ListItem
              style={{ padding: 0 }}
              alignItems="flex-start"
              onClick={link_vps}
            >
              <ListItemText
                secondary={
                  <>
                    <Typography
                      component="span"
                      sx={{
                        mt: 1,
                        fontWeight: "bold",
                        textAlign: "center",
                        display: "block",
                        color: "black",
                        fontSize: {
                          xs: "0.85rem",
                          sm: "0.8rem",
                          md: "1.0rem",
                        },
                      }}
                    >
                      <span>{total_vps_on} (On)</span>
                      {" / "}
                      <span
                        style={{
                          color: total_vps_off > 0 ? "red" : "black",
                        }}
                      >
                        {total_vps_off} (Off)
                      </span>{" "}
                    </Typography>
                    <Typography
                      component="span"
                      sx={{
                        mt: 0.5,
                        fontWeight: "bold",
                        textAlign: "center",
                        display: "block",
                        color: "black",
                        fontSize: {
                          xs: "0.75rem",
                          sm: "0.8rem",
                          md: "0.8rem",
                        },
                      }}
                    >
                      Total VPS
                    </Typography>
                  </>
                }
              />
            </ListItem>
          </List>
        </div>
      </Grid>
      <Grid item xs={6} sm={6} md={3} sx={{ textAlign: "center" }}>
        <div className="dashboard-panel">
          <List>
            <ListItem
              alignItems="center"
              style={{
                margin: 0,
                display: "flex",
                flexDirection: "column",
                flexWrap: "nowrap",
                alignContent: "center",
                justifyContent: "center",
                alignItems: "center",
                padding: 0,
              }}
              onClick={link_vps}
            >
              <ListItemAvatar
                style={{
                  margin: 0,
                  backgroundColor: "#59C9B6",
                  borderRadius: 6,
                  display: "flex",
                  alignContent: "center",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <ButtonBase style={{ height: 80, width: 100 }}>
                  <Terminal
                    style={{
                      margin: "auto",
                      display: "block",
                      color: "#fff",
                      height: "100%",
                      width: "100%",
                      borderRadius: 5,
                      objectFit: "cover",
                    }}
                  />
                </ButtonBase>
              </ListItemAvatar>
            </ListItem>
            <ListItem
              style={{
                padding: 0,
              }}
              alignItems="flex-start"
              onClick={link_vps}
            >
              <ListItemText
                secondary={
                  <React.Fragment>
                    <Typography
                      component="span"
                      sx={{
                        mt: 1,
                        fontWeight: "bold",
                        textAlign: "center",
                        display: "block",
                        color: "black",
                        fontSize: {
                          xs: "0.85rem",
                          sm: "0.8rem",
                          md: "1.0rem",
                        },
                      }}
                    >
                      {total_available_terminal}
                    </Typography>
                    <Typography
                      component="span"
                      sx={{
                        mt: 0.5,
                        fontWeight: "bold",
                        textAlign: "center",
                        display: "block",
                        color: "black",
                        fontSize: {
                          xs: "0.75rem",
                          sm: "0.8rem",
                          md: "0.8rem",
                        },
                      }}
                    >
                      Available Terminal
                    </Typography>
                  </React.Fragment>
                }
              />
            </ListItem>
          </List>
        </div>
      </Grid>
      <Grid item xs={6} sm={6} md={3} sx={{ textAlign: "center" }}>
        <div className="dashboard-panel">
          <List>
            <ListItem
              alignItems="center"
              style={{
                margin: 0,
                display: "flex",
                flexDirection: "column",
                flexWrap: "nowrap",
                alignContent: "center",
                justifyContent: "center",
                alignItems: "center",
                padding: 0,
              }}
              onClick={link_accounts}
            >
              <ListItemAvatar
                style={{
                  margin: 0,
                  backgroundColor: "#59C9B6",
                  borderRadius: 6,
                  display: "flex",
                  alignContent: "center",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <ButtonBase style={{ height: 80, width: 100 }}>
                  <People
                    style={{
                      margin: "auto",
                      display: "block",
                      color: "#fff",
                      height: "100%",
                      width: "100%",
                      borderRadius: 5,
                      objectFit: "cover",
                    }}
                  />
                </ButtonBase>
              </ListItemAvatar>
            </ListItem>
            <ListItem
              style={{
                padding: 0,
              }}
              alignItems="flex-start"
              onClick={link_accounts}
            >
              <ListItemText
                secondary={
                  <React.Fragment>
                    <Typography
                      component="span"
                      sx={{
                        mt: 1,
                        fontWeight: "bold",
                        textAlign: "center",
                        display: "block",
                        color: "black",
                        fontSize: {
                          xs: "0.85rem",
                          sm: "0.8rem",
                          md: "1.0rem",
                        },
                      }}
                    >
                      {total_account}
                    </Typography>
                    <Typography
                      component="span"
                      sx={{
                        mt: 0.5,
                        fontWeight: "bold",
                        textAlign: "center",
                        display: "block",
                        color: "black",
                        fontSize: {
                          xs: "0.75rem",
                          sm: "0.8rem",
                          md: "0.8rem",
                        },
                      }}
                    >
                      Total Account
                    </Typography>
                  </React.Fragment>
                }
              />
            </ListItem>
          </List>
        </div>
      </Grid>
      <Grid item xs={6} sm={6} md={3} sx={{ textAlign: "center" }}>
        <div className="dashboard-panel">
          <List>
            <ListItem
              alignItems="center"
              style={{
                margin: 0,
                display: "flex",
                flexDirection: "column",
                flexWrap: "nowrap",
                alignContent: "center",
                justifyContent: "center",
                alignItems: "center",
                padding: 0,
              }}
              onClick={link_accounts}
            >
              <ListItemAvatar
                style={{
                  margin: 0,
                  backgroundColor: "#59C9B6",
                  borderRadius: 6,
                  display: "flex",
                  alignContent: "center",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <ButtonBase style={{ height: 80, width: 100 }}>
                  <People
                    style={{
                      margin: "auto",
                      display: "block",
                      color: "#fff",
                      height: "100%",
                      width: "100%",
                      borderRadius: 5,
                      objectFit: "cover",
                    }}
                  />
                </ButtonBase>
              </ListItemAvatar>
            </ListItem>
            <ListItem
              style={{
                padding: 0,
              }}
              alignItems="flex-start"
              button
              onClick={link_accounts}
            >
              <ListItemText
                secondary={
                  <React.Fragment>
                    <Typography
                      component="span"
                      sx={{
                        mt: 1,
                        fontWeight: "bold",
                        textAlign: "center",
                        display: "block",
                        color: "black",
                        fontSize: {
                          xs: "0.85rem",
                          sm: "0.8rem",
                          md: "1.0rem",
                        },
                      }}
                    >
                      {total_account_active}
                    </Typography>
                    <Typography
                      component="span"
                      sx={{
                        mt: 0.5,
                        fontWeight: "bold",
                        textAlign: "center",
                        display: "block",
                        color: "black",
                        fontSize: {
                          xs: "0.75rem",
                          sm: "0.8rem",
                          md: "0.8rem",
                        },
                      }}
                    >
                      Active Account
                    </Typography>
                  </React.Fragment>
                }
              />
            </ListItem>
          </List>
        </div>
      </Grid>
    </Grid>
    <Grid Grid container spacing={2} mb={3}>
      <Grid item xs={6} sm={6} md={3} sx={{ textAlign: "center" }}>
        <div className="dashboard-panel">
          <List>
            <ListItem
              alignItems="center"
              style={{
                margin: 0,
                display: "flex",
                flexDirection: "column",
                flexWrap: "nowrap",
                alignContent: "center",
                justifyContent: "center",
                alignItems: "center",
                padding: 0,
              }}
              onClick={link_accounts}
            >
              <ListItemAvatar
                style={{
                  margin: 0,
                  backgroundColor: "#59C9B6",
                  borderRadius: 6,
                  display: "flex",
                  alignContent: "center",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <ButtonBase style={{ height: 80, width: 100 }}>
                  <AccountBalanceWallet
                    style={{
                      margin: "auto",
                      display: "block",
                      color: "#fff",
                      height: "100%",
                      width: "100%",
                      borderRadius: 5,
                      objectFit: "cover",
                    }}
                  />
                </ButtonBase>
              </ListItemAvatar>
            </ListItem>
            <ListItem
              style={{
                padding: 0,
              }}
              alignItems="flex-start"
              onClick={link_accounts}
            >
              <ListItemText
                secondary={
                  <React.Fragment>
                    <Typography
                      component="span"
                      sx={{
                        mt: 1,
                        fontWeight: "bold",
                        textAlign: "center",
                        display: "block",
                        color: "black",
                        fontSize: {
                          xs: "0.85rem",
                          sm: "0.8rem",
                          md: "1.0rem",
                        },
                      }}
                    >
                      {total_balance}
                    </Typography>
                    <Typography
                      component="span"
                      sx={{
                        mt: 0.5,
                        fontWeight: "bold",
                        textAlign: "center",
                        display: "block",
                        color: "black",
                        fontSize: {
                          xs: "0.75rem",
                          sm: "0.8rem",
                          md: "0.8rem",
                        },
                      }}
                    >
                      Daily Balance
                    </Typography>
                  </React.Fragment>
                }
              />
            </ListItem>
          </List>
        </div>
      </Grid>
      <Grid item xs={6} sm={6} md={3} sx={{ textAlign: "center" }}>
        <div className="dashboard-panel">
          <List>
            <ListItem
              alignItems="center"
              style={{
                margin: 0,
                display: "flex",
                flexDirection: "column",
                flexWrap: "nowrap",
                alignContent: "center",
                justifyContent: "center",
                alignItems: "center",
                padding: 0,
              }}
              onClick={link_accounts}
            >
              <ListItemAvatar
                style={{
                  margin: 0,
                  backgroundColor: "#59C9B6",
                  borderRadius: 6,
                  display: "flex",
                  alignContent: "center",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <ButtonBase style={{ height: 80, width: 100 }}>
                  <MonetizationOn
                    style={{
                      margin: "auto",
                      display: "block",
                      color: "#fff",
                      height: "100%",
                      width: "100%",
                      borderRadius: 5,
                      objectFit: "cover",
                    }}
                  />
                </ButtonBase>
              </ListItemAvatar>
            </ListItem>
            <ListItem
              style={{
                padding: 0,
              }}
              alignItems="flex-start"
              onClick={link_accounts}
            >
              <ListItemText
                secondary={
                  <React.Fragment>
                    <Typography
                      component="span"
                      sx={{
                        mt: 1,
                        fontWeight: "bold",
                        textAlign: "center",
                        display: "block",
                        color: "black",
                        fontSize: {
                          xs: "0.85rem",
                          sm: "0.8rem",
                          md: "1.0rem",
                        },
                      }}
                    >
                      {total_equity}
                    </Typography>
                    <Typography
                      component="span"
                      sx={{
                        mt: 0.5,
                        fontWeight: "bold",
                        textAlign: "center",
                        display: "block",
                        color: "black",
                        fontSize: {
                          xs: "0.75rem",
                          sm: "0.8rem",
                          md: "0.8rem",
                        },
                      }}
                    >
                      Daily Equity
                    </Typography>
                  </React.Fragment>
                }
              />
            </ListItem>
          </List>
        </div>
      </Grid>
      <Grid item xs={6} sm={6} md={3} sx={{ textAlign: "center" }}>
        <div className="dashboard-panel">
          <List>
            <ListItem
              alignItems="center"
              style={{
                margin: 0,
                display: "flex",
                flexDirection: "column",
                flexWrap: "nowrap",
                alignContent: "center",
                justifyContent: "center",
                alignItems: "center",
                padding: 0,
              }}
              onClick={link_daily_profit}
            >
              <ListItemAvatar
                style={{
                  margin: 0,
                  backgroundColor: "#59C9B6",
                  borderRadius: 6,
                  display: "flex",
                  alignContent: "center",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <ButtonBase style={{ height: 80, width: 100 }}>
                  <TrendingUp
                    style={{
                      margin: "auto",
                      display: "block",
                      color: "#fff",
                      height: "100%",
                      width: "100%",
                      borderRadius: 5,
                      objectFit: "cover",
                    }}
                  />
                </ButtonBase>
              </ListItemAvatar>
            </ListItem>
            <ListItem
              style={{
                padding: 0,
              }}
              alignItems="flex-start"
              onClick={link_daily_profit}
            >
              <ListItemText
                secondary={
                  <React.Fragment>
                    <Typography
                      component="span"
                      sx={{
                        mt: 1,
                        fontWeight: "bold",
                        textAlign: "center",
                        display: "block",
                        color: "black",
                        fontSize: {
                          xs: "0.85rem",
                          sm: "0.8rem",
                          md: "1.0rem",
                        },
                      }}
                    >
                      {total_daily_profit}
                    </Typography>
                    <Typography
                      component="span"
                      sx={{
                        mt: 0.5,
                        fontWeight: "bold",
                        textAlign: "center",
                        display: "block",
                        color: "black",
                        fontSize: {
                          xs: "0.75rem",
                          sm: "0.8rem",
                          md: "0.8rem",
                        },
                      }}
                    >
                      Daily Profit
                    </Typography>
                  </React.Fragment>
                }
              />
            </ListItem>
          </List>
        </div>
      </Grid>
      <Grid item xs={6} sm={6} md={3} sx={{ textAlign: "center" }}>
        <div className="dashboard-panel">
          <List>
            <ListItem
              alignItems="center"
              style={{
                margin: 0,
                display: "flex",
                flexDirection: "column",
                flexWrap: "nowrap",
                alignContent: "center",
                justifyContent: "center",
                alignItems: "center",
                padding: 0,
              }}
            >
              <ListItemAvatar
                style={{
                  margin: 0,
                  backgroundColor: "#59C9B6",
                  borderRadius: 6,
                  display: "flex",
                  alignContent: "center",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <ButtonBase style={{ height: 80, width: 100 }}>
                  <Timeline
                    style={{
                      margin: "auto",
                      display: "block",
                      color: "#fff",
                      height: "100%",
                      width: "100%",
                      borderRadius: 5,
                      objectFit: "cover",
                    }}
                  />
                </ButtonBase>
              </ListItemAvatar>
            </ListItem>
            <ListItem
              style={{
                padding: 0,
              }}
              alignItems="flex-start"
            >
              <ListItemText
                secondary={
                  <React.Fragment>
                    <Typography
                      component="span"
                      sx={{
                        mt: 1,
                        fontWeight: "bold",
                        textAlign: "center",
                        display: "block",
                        color: "black",
                        fontSize: {
                          xs: "0.85rem",
                          sm: "0.8rem",
                          md: "1.0rem",
                        },
                      }}
                    >
                      {total_sum_profit}
                    </Typography>
                    <Typography
                      component="span"
                      sx={{
                        mt: 0.5,
                        fontWeight: "bold",
                        textAlign: "center",
                        display: "block",
                        color: "black",
                        fontSize: {
                          xs: "0.75rem",
                          sm: "0.8rem",
                          md: "0.8rem",
                        },
                      }}
                    >
                      Total Profit
                    </Typography>
                  </React.Fragment>
                }
              />
            </ListItem>
          </List>
        </div>
      </Grid>
    </Grid>
    <Grid Grid container spacing={2} mb={3}>
      <Grid item xs={6} sm={6} md={3} sx={{ textAlign: "center" }}>
        <div className="dashboard-panel">
          <List>
            <ListItem
              alignItems="center"
              style={{
                margin: 0,
                display: "flex",
                flexDirection: "column",
                flexWrap: "nowrap",
                alignContent: "center",
                justifyContent: "center",
                alignItems: "center",
                padding: 0,
              }}
              onClick={link_daily_deposit}
            >
              <ListItemAvatar
                style={{
                  margin: 0,
                  backgroundColor: "#59C9B6",
                  borderRadius: 6,
                  display: "flex",
                  alignContent: "center",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <ButtonBase style={{ height: 80, width: 100 }}>
                  <Payment
                    style={{
                      margin: "auto",
                      display: "block",
                      color: "#fff",
                      height: "100%",
                      width: "100%",
                      borderRadius: 5,
                      objectFit: "cover",
                    }}
                  />
                </ButtonBase>
              </ListItemAvatar>
            </ListItem>
            <ListItem
              style={{
                padding: 0,
              }}
              alignItems="flex-start"
              onClick={link_daily_deposit}
            >
              <ListItemText
                secondary={
                  <React.Fragment>
                    <Typography
                      component="span"
                      sx={{
                        mt: 1,
                        fontWeight: "bold",
                        textAlign: "center",
                        display: "block",
                        color: "black",
                        fontSize: {
                          xs: "0.85rem",
                          sm: "0.8rem",
                          md: "1.0rem",
                        },
                      }}
                    >
                      {total_daily_deposit}
                    </Typography>
                    <Typography
                      component="span"
                      sx={{
                        mt: 0.5,
                        fontWeight: "bold",
                        textAlign: "center",
                        display: "block",
                        color: "black",
                        fontSize: {
                          xs: "0.75rem",
                          sm: "0.8rem",
                          md: "0.8rem",
                        },
                      }}
                    >
                      Daily Deposit
                    </Typography>
                  </React.Fragment>
                }
              />
            </ListItem>
          </List>
        </div>
      </Grid>
      <Grid item xs={6} sm={6} md={3} sx={{ textAlign: "center" }}>
        <div className="dashboard-panel">
          <List>
            <ListItem
              alignItems="center"
              style={{
                margin: 0,
                display: "flex",
                flexDirection: "column",
                flexWrap: "nowrap",
                alignContent: "center",
                justifyContent: "center",
                alignItems: "center",
                padding: 0,
              }}
            >
              <ListItemAvatar
                style={{
                  margin: 0,
                  backgroundColor: "#59C9B6",
                  borderRadius: 6,
                  display: "flex",
                  alignContent: "center",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <ButtonBase style={{ height: 80, width: 100 }}>
                  <Payments
                    style={{
                      margin: "auto",
                      display: "block",
                      color: "#fff",
                      height: "100%",
                      width: "100%",
                      borderRadius: 5,
                      objectFit: "cover",
                    }}
                  />
                </ButtonBase>
              </ListItemAvatar>
            </ListItem>
            <ListItem
              style={{
                padding: 0,
              }}
              alignItems="flex-start"
            >
              <ListItemText
                secondary={
                  <React.Fragment>
                    <Typography
                      component="span"
                      sx={{
                        mt: 1,
                        fontWeight: "bold",
                        textAlign: "center",
                        display: "block",
                        color: "black",
                        fontSize: {
                          xs: "0.85rem",
                          sm: "0.8rem",
                          md: "1.0rem",
                        },
                      }}
                    >
                      {total_sum_deposit}
                    </Typography>
                    <Typography
                      component="span"
                      sx={{
                        mt: 0.5,
                        fontWeight: "bold",
                        textAlign: "center",
                        display: "block",
                        color: "black",
                        fontSize: {
                          xs: "0.75rem",
                          sm: "0.8rem",
                          md: "0.8rem",
                        },
                      }}
                    >
                      Total Deposit
                    </Typography>
                  </React.Fragment>
                }
              />
            </ListItem>
          </List>
        </div>
      </Grid>
      <Grid item xs={6} sm={6} md={3} sx={{ textAlign: "center" }}>
        <div className="dashboard-panel">
          <List>
            <ListItem
              alignItems="center"
              style={{
                margin: 0,
                display: "flex",
                flexDirection: "column",
                flexWrap: "nowrap",
                alignContent: "center",
                justifyContent: "center",
                alignItems: "center",
                padding: 0,
              }}
              onClick={link_daily_withdrawal}
            >
              <ListItemAvatar
                style={{
                  margin: 0,
                  backgroundColor: "#59C9B6",
                  borderRadius: 6,
                  display: "flex",
                  alignContent: "center",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <ButtonBase style={{ height: 80, width: 100 }}>
                  <TrendingDown
                    style={{
                      margin: "auto",
                      display: "block",
                      color: "#fff",
                      height: "100%",
                      width: "100%",
                      borderRadius: 5,
                      objectFit: "cover",
                    }}
                  />
                </ButtonBase>
              </ListItemAvatar>
            </ListItem>
            <ListItem
              style={{
                padding: 0,
              }}
              alignItems="flex-start"
              onClick={link_daily_withdrawal}
            >
              <ListItemText
                secondary={
                  <React.Fragment>
                    <Typography
                      component="span"
                      sx={{
                        mt: 1,
                        fontWeight: "bold",
                        textAlign: "center",
                        display: "block",
                        color: "black",
                        fontSize: {
                          xs: "0.85rem",
                          sm: "0.8rem",
                          md: "1.0rem",
                        },
                      }}
                    >
                      {total_daily_wd}
                    </Typography>
                    <Typography
                      component="span"
                      sx={{
                        mt: 0.5,
                        fontWeight: "bold",
                        textAlign: "center",
                        display: "block",
                        color: "black",
                        fontSize: {
                          xs: "0.75rem",
                          sm: "0.8rem",
                          md: "0.8rem",
                        },
                      }}
                    >
                      Daily Withdrawal
                    </Typography>
                  </React.Fragment>
                }
              />
            </ListItem>
          </List>
        </div>
      </Grid>
      <Grid item xs={6} sm={6} md={3} sx={{ textAlign: "center" }}>
        <div className="dashboard-panel">
          <List>
            <ListItem
              alignItems="center"
              style={{
                margin: 0,
                display: "flex",
                flexDirection: "column",
                flexWrap: "nowrap",
                alignContent: "center",
                justifyContent: "center",
                alignItems: "center",
                padding: 0,
              }}
            >
              <ListItemAvatar
                style={{
                  margin: 0,
                  backgroundColor: "#59C9B6",
                  borderRadius: 6,
                  display: "flex",
                  alignContent: "center",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <ButtonBase style={{ height: 80, width: 100 }}>
                  <RemoveCircleOutline
                    style={{
                      margin: "auto",
                      display: "block",
                      color: "#fff",
                      height: "100%",
                      width: "100%",
                      borderRadius: 5,
                      objectFit: "cover",
                    }}
                  />
                </ButtonBase>
              </ListItemAvatar>
            </ListItem>
            <ListItem
              style={{
                padding: 0,
              }}
              alignItems="flex-start"
            >
              <ListItemText
                secondary={
                  <React.Fragment>
                    <Typography
                      component="span"
                      sx={{
                        mt: 1,
                        fontWeight: "bold",
                        textAlign: "center",
                        display: "block",
                        color: "black",
                        fontSize: {
                          xs: "0.85rem",
                          sm: "0.8rem",
                          md: "1.0rem",
                        },
                      }}
                    >
                      {total_sum_withdrawal}
                    </Typography>
                    <Typography
                      component="span"
                      sx={{
                        mt: 0.5,
                        fontWeight: "bold",
                        textAlign: "center",
                        display: "block",
                        color: "black",
                        fontSize: {
                          xs: "0.75rem",
                          sm: "0.8rem",
                          md: "0.8rem",
                        },
                      }}
                    >
                      Total Withdrawal
                    </Typography>
                  </React.Fragment>
                }
              />
            </ListItem>
          </List>
        </div>
      </Grid>
    </Grid>
  </>
);
const TableDataVps = React.memo(({ tableData, tableColumns }) => (
  <div className="box-container">
    <ReactTable
      data={tableData}
      columns={tableColumns}
      style={{ backgroundColor: "#f2f2f2" }}
      filterable
      defaultFilterMethod={(filter, row) => {
        const cellValue = String(row[filter.id]).toLowerCase();
        return cellValue.includes(filter.value.toLowerCase());
      }}
      defaultPageSize={500}
      showPageJump={false}
      showPageSizeOptions={false}
      showPagination={false}
      getTableProps={() => {
        return {
          onScroll: (e) => {
            let left = e.target.scrollLeft > 0 ? e.target.scrollLeft : 0;
            $(".ReactTable .rt-tr .frozen").css({ left: left });
          },
        };
      }}
    />
  </div>
));

const AlertInfo = ({
  openSnackbar,
  snackbarSeverity,
  snackbarMessage,
  handleCloseSnackbar,
}) => (
  <Snackbar
    anchorOrigin={{ vertical: "top", horizontal: "right" }}
    open={openSnackbar}
    autoHideDuration={6000}
    onClose={handleCloseSnackbar}
    style={{ marginTop: "80px" }}
  >
    <MuiAlert
      variant="filled"
      onClose={handleCloseSnackbar}
      severity={snackbarSeverity}
    >
      {snackbarMessage}
    </MuiAlert>
  </Snackbar>
);

export default Dashboard;
